/* eslint-disable @typescript-eslint/no-unsafe-function-type */
import { MonarchEvaluationsError } from '@redventures/cohesion-utils-react';
import {
  cohesionReady,
  monarchDone,
  cohesionCatch,
  monitorOnError,
} from './monarchEvents';
import { MonarchEvaluationsValue } from 'pages';

export const setMonarchMonitoring = () => {
  if (typeof window === 'undefined') {
    // Handle server-side rendering case
    console.warn('window is not available in this environment');
    return;
  }

  try {
    // Send a page action to new relic when cohesion is ready.
    (window as { cohesion: Function }).cohesion('ready', cohesionReady);

    // Event listener that will listen for Monarch to be done loading
    (window as { cohesion: Function }).cohesion(
      'monarch:done',
      (err: MonarchEvaluationsError, evaluation: MonarchEvaluationsValue) => {
        monarchDone(err, evaluation);
      }
    );

    // Event listener that will listen for any errors that occur in while loading the Cohesion SCript
    (window as { cohesion: Function }).cohesion('error', monitorOnError);
  } catch (error: unknown) {
    cohesionCatch(error);
  }
};
